import {
    type VoipCxOwner,
    type VoipEngOwner,
    type VoipIntegrationType,
    type VoipPhoneProvider,
} from '@libraries/typescript/api_client';

// Sentinel for "not set" in Select fields (Radix Select forbids '' values).
export const NONE_VALUE = 'none';

type VoipOption<Value extends string> = {
    readonly value: Value;
    readonly label: string;
};

function buildVoipOptions<Value extends string>(
    labels: Record<Value, string>,
): ReadonlyArray<VoipOption<Value>> {
    return (Object.entries(labels) as Array<[Value, string]>).map(
        ([value, label]) => ({ value, label }),
    );
}

export const VOIP_PHONE_PROVIDER_LABELS = {
    goto: 'GoTo',
    dialpad: 'Dialpad',
    ringcentral: 'RingCentral',
    zoom_phone: 'Zoom Phone',
    vonage: 'Vonage',
    ringplan: 'RingPlan',
    verticomm_intermedia: 'Verticomm / Intermedia',
    elevate_pacific_automation: 'Elevate / Pacific Automation',
    podium_quo: 'Quo / OpenPhone',
    generic_forwarding: 'Generic forwarding',
    jep: 'JEP',
    other: 'Other',
} satisfies Record<VoipPhoneProvider, string>;

export const VOIP_INTEGRATION_TYPE_LABELS = {
    native_integration: 'Native Integration',
    generic_phone_adaptor: 'Generic Phone Adaptor',
} satisfies Record<VoipIntegrationType, string>;

const VOIP_CX_OWNER_LABELS = {
    Dash: 'Dash',
    Suket: 'Suket',
    Maya: 'Maya',
    Dave: 'Dave',
    Cindy: 'Cindy',
    Jake: 'Jake',
} satisfies Record<VoipCxOwner, string>;

const VOIP_ENG_OWNER_LABELS = {
    Mila: 'Mila',
    Nate: 'Nate',
    Korgan: 'Korgan',
} satisfies Record<VoipEngOwner, string>;

export const VOIP_PHONE_PROVIDER_OPTIONS = buildVoipOptions(
    VOIP_PHONE_PROVIDER_LABELS,
);
export const VOIP_INTEGRATION_TYPE_OPTIONS = buildVoipOptions(
    VOIP_INTEGRATION_TYPE_LABELS,
);
export const VOIP_CX_OWNER_OPTIONS = buildVoipOptions(VOIP_CX_OWNER_LABELS);
export const VOIP_ENG_OWNER_OPTIONS = buildVoipOptions(VOIP_ENG_OWNER_LABELS);

export function isVoipSwrKey(key: unknown): boolean {
    return (
        Array.isArray(key) &&
        key.length > 1 &&
        typeof key[1] === 'string' &&
        key[1].startsWith('/admin/voip')
    );
}
